import { render, staticRenderFns } from "./CampoBuenoRegularNA.vue?vue&type=template&id=13b93505&scoped=true"
import script from "./CampoBuenoRegularNA.vue?vue&type=script&lang=js"
export * from "./CampoBuenoRegularNA.vue?vue&type=script&lang=js"
import style0 from "./CampoBuenoRegularNA.vue?vue&type=style&index=0&id=13b93505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b93505",
  null
  
)

export default component.exports